import React from 'react';
import { LazyVideo } from '../common/LazyVideo';

interface HowItWorksCardProps {
  step: number;
  gifDark: string;
  gifLight: string;
  videoKey?: string; // Optional: key for optimized video
  title: string;
  description: string;
  subtext: string;
  isDark: boolean;
}

export function HowItWorksCard({ step, gifDark, gifLight, videoKey, title, description, subtext, isDark }: HowItWorksCardProps) {
  return (
    <div className="flex flex-col md:flex-row gap-12 w-full mb-16 md:mb-12">
      {/* Left Side - GIF Card */}
      <div className="w-full md:w-3/5 relative rounded-2xl p-1.5 bg-gradient-to-br from-primary-light/10 via-secondary-light/10 to-primary-light/10 dark:from-primary-dark/10 dark:via-secondary-dark/10 dark:to-primary-dark/10 shadow-lg transition-transform duration-300 ease-out hover:scale-[1.02] group">
        <div className="relative aspect-[3/2] md:aspect-video rounded-xl overflow-hidden bg-gradient-to-br from-background-light/80 to-surface-light/80 dark:from-background-dark/80 dark:to-surface-dark/80 backdrop-blur-md">
          {/* Background Video - Using LazyVideo for performance */}
          <div className="absolute inset-0">
            {videoKey ? (
              <LazyVideo
                darkSrc={gifDark}
                lightSrc={gifLight}
                videoKey={videoKey}
                isDark={isDark}
                autoPlay={true}
                muted={true}
                loop={true}
                playsInline={true}
              />
            ) : (
              <img src={isDark ? gifDark : gifLight} alt={title} className="w-full h-full object-cover" />
            )}
            <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-black/10 to-transparent" />
          </div>
        </div>
      </div>

      {/* Right Side - Text Content */}
      <div className="w-full md:w-2/5 flex flex-col justify-start pt-1 md:pt-4">
        {/* Step Indicator */}
        <div className="mb-4">
          <div className="inline-block px-3 py-1.5 rounded-lg bg-primary-light/10 dark:bg-primary-dark/10 border border-primary-light/20 dark:border-primary-dark/20">
            <span className="text-base font-medium text-primary-light dark:text-primary-dark">
              Step {step}
            </span>
          </div>
        </div>

        <h3 className="text-2xl sm:text-3xl font-bold text-text-primary-light dark:text-text-primary-dark mb-3 mt-0 md:mt-4 sm:mb-4">
          {title}
        </h3>
        <p className="text-base text-text-secondary-light dark:text-text-secondary-dark mb-3">
          {description}
        </p>
        <p className="text-sm text-text-tertiary-light dark:text-text-tertiary-dark">
          {subtext}
        </p>
      </div>
    </div>
  );
}